<template>
  <div>
    <!-- 条件搜索 -->
    <div class="b-conditions-style" v-if="!isFromQuickly">
      <div class="b-con-form">
        <el-checkbox label="只看今天进线" class="yorker-only-repeat" :true-label="1" :false-label="0" v-model="condition.has_repeat" @change="handleChangeOnline"></el-checkbox>
      </div>
      <div class="b-con-form">
        <label class="c-label">报名楼盘：</label>
        <el-input class="b-con-filter-area" v-model="condition.sign_up_house_names" placeholder="请输入楼盘名称" clearable ></el-input>
      </div>
      <div class="b-con-form">
        <label class="c-label">意向区域</label>
        <el-input class="b-con-filter-area" v-model="condition.city_area_name" placeholder="请输入" clearable ></el-input>
      </div>
      <div class="b-con-form">
        <label class="c-label">进线时间</label>
        <el-date-picker class="b-con-filter-area b-con-filter-datetime" v-model="createTimeList" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" align="right"  clearable @change="createTimeChange()" />
      </div>
      <div class="c-con-search-btn">
        <button class="global-btn primary size-1" @click="search">搜索</button>
        <button class="global-btn primary-round size-1" @click="reset">清空</button>
      </div>
    </div>
    <div class="b-inner-menus b-inner-menus-dist" v-if="userInfo.is_no_secret_login != 1 && !isFromQuickly">
      <div class="b-inner-flex">
        <p class="b-i-menu" @click="handleAdd" v-permission="'customer.new.list.import'">
          <i class="el-icon-plus b-i-icon"></i>
          <span>新增</span>
        </p>
        <p class="b-i-menu" @click="$router.push('/customer/custome-import/batch?type=5')"  v-permission="'customer.new.list.import'">
          <i class="iconfont iconhebing b-i-icon"></i>
          <span>批量导入</span>
        </p>
        <p class="b-i-menu" @click="handleDistribute" v-permission="'customer.new.list.distribute'">
          <i class="iconfont iconhebing b-i-icon"></i>
          <span>批量分配</span>
        </p>
        <p class="b-i-menu" @click="handleDownload" v-permission="'customer.new.list.export'">
          <i class="iconfont iconhebing b-i-icon"></i>
          <span>导出</span>
        </p>
      </div>
    </div>
    <cu-table :data="list" :pageData="pageData" :isLoading="isLoading" @currentChange="currentChange" @select="handleSelectChange" @sort-change="handleSort"  class="b-table-hidden-checkbox cu-table-normal-height" :class="isFromQuickly && 'cu-table-normal-height-qucikly'" ref="customeTable">
      <el-table-column type="selection" fixed="left" width="70" v-if="!isFromQuickly"></el-table-column>
      <el-table-column label="客户姓名" min-width="150" fixed="left">
        <p slot-scope="scope" class="b-c-ellipse b-c-cursor" :title="scope.row.name" @click="toCustomeDetail(scope.row)">
          <el-popover placement="top-start" title="" width="340" trigger="hover" v-if="scope.row.latest_repeat_time > 0">
            <p style="text-align: center;">
              {{getRepeatName(scope.row.latest_repeat_time)}}
            </p>
            <span class="yorker-repeat" slot="reference">重复进线</span>
          </el-popover>
          {{scope.row.name || '--'}}
        </p>
      </el-table-column>
      <el-table-column label="手机号码" min-width="150">
        <p slot-scope="scope" class="b-c-ellipse" :title="scope.row.contact_tel">{{scope.row.contact_tel || '--'}}</p>
      </el-table-column>
      <el-table-column label="归属地" min-width="150">
        <p slot-scope="scope" class="b-c-ellipse" :title="scope.row.contact_tel_location">{{scope.row.contact_tel_location || '--'}}</p>
      </el-table-column>
      <el-table-column label="报名楼盘" min-width="150">
        <p slot-scope="scope" class="b-c-ellipse" :title="scope.row.sign_up_house_names">{{scope.row.sign_up_house_names || '--'}}</p>
      </el-table-column>
      <el-table-column label="意向区域" min-width="150">
        <p slot-scope="scope" class="b-c-ellipse" :title="scope.row.city_names">{{scope.row.city_names || '--'}}</p>
      </el-table-column>
      <el-table-column label="来源" min-width="200">
        <p slot-scope="scope" class="b-c-ellipse" :title="scope.row.all_source_name">{{scope.row.all_source_name || '--'}}</p>
      </el-table-column>
      <el-table-column label="创客时间" min-width="180" prop="created_at" sortable>
        <p slot-scope="scope" class="b-c-ellipse" v-analysis-time:all="scope.row.created_at"></p>
      </el-table-column>
      <template slot="operate">
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="scope" >
            <div class="table-operation">
              <a class="ope-item" @click="toDistribution(scope.row)" v-permission="'customer.new.list.distribute'">分配</a>
              <a class="ope-item" @click="toGetCustome(scope.row)"  v-permission="'customer.new.list.loot'">抢客</a>
            </div>
          </template>
        </el-table-column>
      </template>
      <template slot="pageLeft" v-if="!isFromQuickly">
        <el-checkbox label="选中本页" v-model="checkCurrent" @change="handleOnlyChange" style="margin-left: 5px;margin-right: 10px;"></el-checkbox>
        <el-checkbox label="选中全部" v-model="isCheckAll" @change="handleChangeCheck" style="margin-left: 5px;"></el-checkbox>
        <span class="b-c-check-label">共选中 {{checkTotal}} 条数据</span>
      </template>
    </cu-table>

    <!--  分配弹层 -->
    <el-dialog :append-to-body="true" :visible.sync="isShowUserSelect" @closed="cancel" title="请选择分配的经纪人" center :show-close="false" width="480px" custom-class="approve-edit-con" :close-on-click-modal="false" :close-on-press-escape="false">
      <a class="close-con" @click="isShowUserSelect = false">
        <i class="iconfont iconshanchu"></i>
      </a>
      <div class="move-con">
        <div class="move-box">
          <span class="label">{{!isSingleSelect ? checkTotal + '个客户分配给' : '将客户分配给'}}：</span>
          <el-cascader v-model="customeName" :show-all-levels="false" :props="customeOptions" :options="customerList" class="input" placeholder="请选择经纪人" clearable></el-cascader>
        </div>
      </div>
      <div class="move-btn-list">
        <el-button type="primary" @click="confirm">确定</el-button>
        <el-button @click="cancel">取消</el-button>
      </div>
    </el-dialog>
    <!-- 校验手机号 -->
    <el-dialog :visible.sync="isCheckMobile" :append-to-body="true" :closed="handleCheckMobileCancel" title="新增客户" center :show-close="false" width="400px" custom-class="approve-edit-con" :close-on-click-modal="false" :close-on-press-escape="false">
      <a class="close-con" @click="handleCheckMobileCancel">
        <i class="iconfont iconshanchu"></i>
      </a>
      <el-input placeholder="请输入新增客户手机号" maxlength="11" class="news-mobile" v-model="c_mobile" />
      <p class="desc">手机号码作为客户唯一判重标准，新增客户前需校验手机号是否重复</p>
      <div class="move-btn-list">
        <el-button type="primary" @click="handleConfirmMobile">校验</el-button>
        <el-button @click="handleCheckMobileCancel">取消</el-button>
      </div>
    </el-dialog>
    <!-- 新增客户 -->
    <custome-add ref="customAdd" />
  </div>
</template>
<script>
import CuTable from '@/components/cTable';
import CustomeAdd from './component/customeAdd';
import customeMixins from '../mixins/operate';
import {validateMobileReg} from '@/utils/validate';
import {getAllCompanyMember, searchCustome, checkCustomerMobile} from '@/api/base';
import {getGuestCustomer, setGuestDistribution, exportYorkerBeDistri, guestTakeUser, guestCustomerExport} from '@/api/custome';
import { mapState } from 'vuex';
export default{
  name: 'BeDistributed',
  components: {CuTable,CustomeAdd},
  mixins: [customeMixins],
  props: {
    // 是否来自于快捷搜索结果显示页(只展示部分内容)
    isFromQuickly: {
      type: Boolean,
      default: false
    },
    searchParameters: {
      type: Object
    }
  },
  watch: {
    searchParameters: {
      handler: function(val, oldVal) {
        if (!val) return null;
        this.condition = {
          has_repeat: 0,
          sign_up_house_names: ''
        }
        this.initList();
      },
      immediate: true,
      deep: true
    }
  },
  data () {
    return {
      isCheckMobile: false, // 检验手机号开关
      c_mobile: '',
      condition: {
        has_repeat: 0,
        sign_up_house_names: ''
      },
      list: [],
      isLoading: false,
      pageData: {
        total: 0,
        page: 1,
        per_page: 20
      },
       // 复选框数据
      isCheckAll: false,
      checkedList: [],
      unCheckedList: [],
      currentPageCheckList:[],
      currentCheckedAll:false,

      isShowUserSelect: false,
      customerList: [],
      customeName: [],
      customeOptions: {
        label: 'name',
        value: 'id',
        expandTrigger: 'hover'
      },
      checkCurrent: false,
      isSingleSelect: false,
      createTimeList: [],
        isHide: null
    }
  },
  computed: {
    ...mapState({
      emitName: state => state.const.emitName,
      userInfo: state => state.user.userInfo
    }),
    checkTotal () {
      if (this.isCheckAll) return this.pageData.total;
      if (this.unCheckedList.length) return this.pageData.total - this.unCheckedList.length;
      if(this.checkCurrent || this.currentPageCheckList.length) return this.currentPageCheckList.length
      return this.checkedList.length;
    }
  },
  created() {
    this.initList();
    this.$nextTick(() => {
      this.$table = this.$refs?.customeTable?.refrench();
    })
    this.$EventBus.$on(`NewYorker_refresh`, this.initList);
  },
  beforeDestroy() {
     this.$EventBus.$off(`NewYorker_refresh`);
  },
  methods: {
    createTimeChange () {
      this.condition.created_at_start = this.createTimeList ? this.createTimeList[0] : '';
      this.condition.created_at_end = this.createTimeList ? this.createTimeList[1] : '';
    },
    async initList (page) {
      if (!this.isFromQuickly) {
        this.initNormalList();
      } else {
        this.initSearchList(page);
      }
    },
    // 新客池列表数据
    async initNormalList () {
      this.isLoading = true;
      this.checkCurrent = false
      this.currentPageCheckList = [];
      try {
        this.$table?.clearSelection();
        const params = {
          ...this.condition,
          ...this.pageData
        }
        const date = new Date();
        params.created_at_start = params.has_repeat === 0 ? (params.created_at_start || '') : `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
        delete params.has_repeat;
        const res = await getGuestCustomer(params);
        this.list = res.data || [];
        this.isHide = res.is_hide;
        this.$set(this.pageData, 'total', res.total);
        this.$nextTick(_ => {
          this.switchDataChecked();
        })
      } catch (error) {
        this.$message.error(error.msg || '操作失败，请重试')
      } finally {
        this.isLoading = false;
      }
    },
    // 新客池快捷搜索列表数据展示
    async initSearchList (page) {
      this.isLoading = true;
      this.pageData.page = page ? page : 1;
      try {
        const params = {
          ...this.condition,
          ...this.pageData,
          ...this.searchParameters,
          status: 5
        }
        const res = await searchCustome(params);
        this.list = res.data || [];
        this.isHide = res.is_hide;
        this.$set(this.pageData, 'total', res.total);
        this.$emit('searchCallback', 'newYorker', res.total)
      } catch (error) {
        this.$message.error(error.msg || '操作失败，请重试')
      } finally {
        this.isLoading = false;
      }
    },
    handleChangeOnline () {
      // 清空已选择日期
      this.createTimeList = [];
      this.condition.created_at_start = '';
      this.condition.created_at_end = '';
      this.search();
    },
    search () {
      this.pageData.page = 1;
      this.clearCheckData()
      this.initList();
    },
    reset () {
      this.createTimeList = [];
      this.condition = {
        has_repeat: 0,
        city_area_name: '',
        sign_up_house_names: ''
      };
      this.pageData = {
        total: 0,
        page: 1,
        per_page: 20
      }
      this.initList();
    },
    currentChange (page) {
      if (page > 2000) {
        this.$message.error('数据太多，请选择更详细的筛选条件');
        return null;
      }
      this.pageData.page = page;
      this.initList(page);
    },
    handleSort (item) {
      this.condition.order_field = item.prop;
      this.condition.order_type = item.order === "ascending" ? 'asc' : 'desc';
      this.initList();
    },
    handleAdd(){
        this.isCheckMobile = true;
        this.c_mobile = '';
    },
    handleCheckMobileCancel () {
        this.isCheckMobile = false;
    },
    async handleConfirmMobile () {
        if (!this.c_mobile) {
            this.$message.error('请输入新增客户手机号');
            return null;
        }
        if (!validateMobileReg(this.c_mobile)) {
            this.$message.error('请输入正确的客户手机号');
            return null;
        }
        try {
            const res = await checkCustomerMobile({
                tel: this.c_mobile
            })
            if (!!res) {
                this.handleCheckError(res, this.c_mobile);
            } else {
                this.openAddCustomer(this.c_mobile);
            }
        } catch (error) {
            this.$message.error(error.message || '操作失败，请重试');
        } finally {
            this.handleCheckMobileCancel();
        }
    },
    // 打开新增客户弹层
    openAddCustomer (tel) {
        this.$refs.customAdd && this.$refs.customAdd.open(tel);
    },
    toCustomeDetail (row) {
      this.$EventBus.$emit(this.emitName, {category: 'customerDetail', params: {
        customerId: row.id
      }});
    },
    toDistribution (row) {
      this.dictriCustomeIds = `${row.id}`;
      this.isShowUserSelect = true;
      this.isSingleSelect = true;
      this.customeName = [];
      this.initAllMember(row.id);
    },
    cancel () {
      this.isShowUserSelect = false;
    },
    confirm () {
      if (this.customeName.length <= 0) {
        this.$message.error('请选择要分配的经纪人');
        return null;
      }
      const single = {
        ids:this.dictriCustomeIds
      }
      const condition = this.isSingleSelect ? single : this.getCheckParam()
      const parameter = {
        admin_id:this.customeName[this.customeName.length - 1],
        ...condition
      }
      setGuestDistribution(parameter).then(res=>{
        if (res.errCode==0){
          this.$message.success('分配成功');
        }
        else{
          this.$message.error(res.errMsg || '操作失败，请重试');
        }
        this.cancel();
        this.initList();
      });





    },
    async initAllMember(id) {
      try {
        const res = await getAllCompanyMember({
          is_all: 0,
          new_customer_id: id || null
        });
        this.customerList = res || [];
      } catch (error) {
        this.$message.error(error.msg || '操作失败，请重试');
      }
    },
    async handleDownload () {
      if (this.pageData.total === 0) {
        this.$message.error('没有可导出的数据');
        return null;
      }
      if(this.isHide){
          try {
              await guestCustomerExport(this.condition);
              this.$EventBus.$emit(`importAnimate`, 1);
          } catch (error) {
              this.$message.error(error.msg || '操作失败，请重试');
          }
      }
      else{
          let h = `<form style="display: flex;align-items: center; margin: 20px 0; justify-content: space-between; ">
            <div class="username"><label>账号：</label><span style="color: #333333;">${this.userInfo.account}</span></div>
            <div class="pwd"><label>密码：</label><input class="el-input__inner" style="height: 30px;line-height: 30px; width: auto;" type="password" id="exportPwd" placeholder="请输入密码" /></div></form>`;
          this.$confirm(`您正在导出「新客池」的客户数据，为确保是本人操作，请在下方输入您的账号密码进行身份验证。${h}`,
              '导出验证', {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              beforeClose: async (action, instance, done) => {
                  if(action == "confirm"){
                      instance.confirmButtonLoading = true;
                      instance.confirmButtonText = '执行中...';
                      try {
                          await guestCustomerExport({...this.condition,...{pwd: document.getElementById("exportPwd").value}});
                          instance.confirmButtonLoading = false;
                          instance.confirmButtonText = '确定';
                          this.$EventBus.$emit(`importAnimate`, 1);
                          done();
                      } catch (error) {
                          instance.confirmButtonLoading = false;
                          instance.confirmButtonText = '确定';
                          this.$message.error(error.msg || '操作失败，请重试');
                      }
                  }
                  else{
                      done();
                  }
              }
          })
      }
    },
    handleDistribute () {
      if (!this.isCheckAll && this.unCheckedList.length <= 0 && this.currentPageCheckList.length <=0) {
        this.$message.error('请先选择客户后再进行分配');
        return null;
      }
      this.isSingleSelect = false;
      this.isShowUserSelect = true;
      this.customeName = [];
      this.initAllMember();
    },
    getCheckParam(){
      const is_all_select = this.currentCheckedAll ? 1 : 0;
      const filter_ids = this.unCheckedList.join(',');
      const ids = this.currentPageCheckList.map(v => v.id).join(',');
      const more =this.isFromQuickly ? (this.searchParameters || {}) : this.condition;
      return {
        is_all_select:is_all_select,
        filter_ids:filter_ids,
        ids:ids,
        ...more,
      }
    },
    // 全选切换事件
    handleChangeCheck (status) {
      if (this.pageData.total >1000) {
        this.$message.error('当前列表数据超过 1 千条，请筛选后再全选');
        setTimeout(() => {
          this.isCheckAll = false;
        }, 100)
        return null;
      }
      if(this.checkCurrent || this.currentPageCheckList.length){
        this.$table?.clearSelection();
      }
      this.currentCheckedAll = status;
      this.checkCurrent = false;
      this.currentPageCheckList = [];
      // 选中列表
      this.$table.toggleAllSelection(status);
      // 清空已选列表
      this.checkedList = [];
      this.unCheckedList = [];
    },

    // 列表选中事件
    handleSelectChange (list, row) {
      // 判断当前文本框选中/取消选中
      const data = list.find(v => v.id == row.id);
      // 判断当前取值范围
      if (this.currentCheckedAll) {
        if (!data) {
          this.unCheckedList.push(row.id);
        } else {
          const index = this.unCheckedList.findIndex(v => v == data.id);
          if (index >= 0) this.unCheckedList.splice(index, 1);
        }
        // 更改全选反选
        this.isCheckAll = this.unCheckedList.length <= 0;
      } else {
        if (data) {
          this.currentPageCheckList.push(data);
        } else {
          const index = this.currentPageCheckList.findIndex(v => v.id == row.id);
          if (index >= 0) this.currentPageCheckList.splice(index, 1);
        }
        this.checkCurrent = this.currentPageCheckList.length === this.list.length
        // 更改全选反选
        this.isCheckAll = this.currentPageCheckList.length >= this.pageData.total;
      }
    },
        // 切换选中数据
    switchDataChecked () {
      if (this.isCheckAll) {
        this.$table.toggleAllSelection(true);
        return null;
      }
      // 过滤未选中数据
      if (this.currentCheckedAll ) {
        this.list.map(v => {
          const index = this.unCheckedList.findIndex(a => a == v.id);
          this.$table.toggleRowSelection(v, index < 0);
        })
        return null;
      }
      // 添加选中数据
      if (!this.currentCheckedAll) {
        this.checkedList.map(v => {
          const row = this.list.find(a => a.id == v);
          if (row) this.$table.toggleRowSelection(row, true);
        })
      }
    },
    handleOnlyChange () {
      if(this.isCheckAll || this.unCheckedList.length){
        this.$table?.clearSelection();
      }
      this.isCheckAll = false;
      this.checkedList = [];
      this.unCheckedList = [];
      this.currentCheckedAll = false;
      if (this.checkCurrent) {
        this.$table?.toggleAllSelection(true);
        this.currentPageCheckList = [...this.list];
      } else {
        this.$table?.clearSelection();
        this.currentPageCheckList = [];
      }
      console.log(this.currentPageCheckList)
    },
    // 清空选中数据
    clearCheckData () {
      this.currentCheckedAll = false;
      this.isCheckAll = false;
      this.unCheckedList = [];
      this.checkedList = [];
      this.currentPageCheckList = [];
    },
    getRepeatName (time) {
      const date = new Date(time * 1000);
      const M = (date.getMonth() + 1).toString().padStart(2, '0');
      const d = date.getDate().toString().padStart(2, '0');
      const h = date.getHours().toString().padStart(2, '0');
      const m = date.getMinutes().toString().padStart(2, '0');
      const s = date.getSeconds().toString().padStart(2, '0');
      return `最后进线时间：${date.getFullYear()}年${M}月${d}日 ${h}时${m}分${s}秒`;
    },
    toGetCustome (row) {
      this.$confirm('确认领取该客户？', '操作提示', {
        customClass: 'custom-delete-dialog'
      }).then(async _ => {
        try {
          await guestTakeUser({
            customer_id: row.id,
            csrf_token: row.csrf_token
          });
          this.$message.success('抢客成功');
          this.initList();
        } catch (error) {
          this.$message.error(error.msg || '操作失败，请重试');
          this.initList();
        }
      }).catch(e => {})
    }
  },
}
</script>

<style lang="less">
@import url('~@/assets/style/base/condition.less');
@import url('~@/assets/style/approve.less');
@import url('~@/assets/style/base/search.less');
.news-mobile{
  display: block;
  width: 350px;
  margin: 20px auto 10px;
}
.approve-edit-con{
  .desc{
    font-size: 12px;
    color: #999;
    margin-bottom: 30px;
    padding: 0px 30px;
    line-height: 20px;
    &::before{
      content: '*';
      color: red;
    }
  }
}
.yorker-repeat{
  background: #FFEBEB;
  color: #FF413C;
  display: inline-block;
  height: 20px;
  border-radius: 5px;
  font-size: 12px;
  padding: 0 6px;
}
.el-message-box__header{ background: #f1f1f1;}
.el-message-box__btns{ text-align: center;}
</style>
<style scoped lang="less">
.move-con{
  padding: 10px 0 30px;
}
.move-box{
  .box();
  margin-top: 10px;
  .label{
    line-height: 45px;
    text-align: right;
    display: block;
    font-size: 14px;
    color: #666;
  }
  .input{
    width: 300px;
  }
}
.cu-table-normal-height-qucikly{
  height: calc(100VH - 200px) !important;
}
</style>
